import http from "./http"; // axios instance

// 🔹 ADD WALLET (CREDIT)
export const adminWalletAdd = async (data) => {
  // data = { user_id, amount, remarks }
  const res = await http.post("wallet_add", data);
  return res.data;
};

// 🔹 REMOVE WALLET AMOUNT (DEBIT)
export const adminWalletRemove = async (data) => {
  // data = { user_id, amount, remarks }
  const res = await http.post("remove_admin_amount", data);
  return res.data;
};

// 🔹 GET ADMIN WALLET HISTORY
export const getAdminWalletHistory = async () => {
  const res = await http.get("admin-wallet-history");
  return res.data;
};
